import { Tooltip } from '../ui/tooltip'
import type { PriorityScore } from '../../constants/leadPriority'
import { PRIORITY_TOOLTIP } from '../../constants/leadPriority'

const DOT_CLASS: Record<PriorityScore, string> = {
  green: 'bg-emerald-500',
  yellow: 'bg-amber-400',
  red: 'bg-red-500',
}

interface StoplightBadgeProps {
  score?: PriorityScore
  reason?: string
  tooltipSide?: 'top' | 'bottom' | 'left' | 'right'
}

export function StoplightBadge({ score, reason, tooltipSide = 'top' }: StoplightBadgeProps) {
  const tooltip = reason?.trim() ? reason : score ? PRIORITY_TOOLTIP[score] : ''

  return (
    <span className="inline-flex h-3 w-3 flex-shrink-0 items-center justify-center" aria-hidden={!score}>
      {score ? (
        <Tooltip content={tooltip} side={tooltipSide}>
          <span
            className={`inline-block h-3 w-3 rounded-full ring-2 ring-white shadow-sm ${DOT_CLASS[score]}`}
            aria-label={tooltip}
            role="img"
          />
        </Tooltip>
      ) : null}
    </span>
  )
}
